export default "__VITE_ASSET__4jnzvbzo__"